import { CHATBOT_ID } from '../constants/chatbotId';
import { IChatbotMessageSchema } from '../types/chatbot';
import { TMessageSchema } from '../types/messages';

export const mapChatbotMessageToChatMessage = (
  message: IChatbotMessageSchema,
  index?: number,
  unreadMessagesCount?: number,
): TMessageSchema => {
  const { offers, created } = message;

  const createdMs = new Date(created).getTime();

  return {
    ...message,
    chatId: CHATBOT_ID,
    offers:
      offers?.map(offer => ({
        ...offer,
        url: `/sale/flat/${offer.realtyOfferId}/`,
      })) || [],
    userId: 0,
    created: createdMs,
    createdMs,
    unread: index !== undefined && !!unreadMessagesCount && index < unreadMessagesCount - 1,
  };
};
